import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackDiscovery } from '../../services/discovery.service';
export default function DiscoveryTracker() {
 const location=useLocation(); const previous=useRef('');
 useEffect(()=>{if(previous.current===location.pathname) return;previous.current=location.pathname;
  if (/^\/$|^\/(browse|drivers|car-rental-kigali|suv-rental-rwanda|car-rental-with-driver)$/.test(location.pathname)) trackDiscovery('page_view');
 },[location.pathname]); return null;
}
